import * as React from 'react';

const HomeFilled24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M13.954 2.753c-1.074-1.004-2.803-1.004-3.877 0l-7.245 6.79A2.58 2.58 0 0 0 2 11.432v7.908c0 1.495 1.284 2.642 2.765 2.642h2.504c.883 0 1.731-.663 1.731-1.628v-4.63c0-.53.169-.788.333-.926.185-.156.472-.249.83-.249h3.674c.358 0 .645.093.83.249.164.138.333.395.333.925v4.64c0 .97.844 1.638 1.731 1.638h2.504C20.716 22 22 20.853 22 19.358v-7.936c0-.71-.301-1.385-.817-1.874l-7.227-6.793z"
  }
));
HomeFilled24.Size = 24;
HomeFilled24.Title = "HomeFilled";

export { HomeFilled24 as default };
